export default {
  jobs: [],
  apiCallsInProgress: 0,
  profile: {},
  claimedJob: {},
  myJobs: [],
  myCompletedJobs: [],
  myInstalledJobs: [],
  myAwaitingPaymentJobs: [],
  myProgressedJobs: [],
  completingJob: {},
};
